export class KansatsuKirokuArchiveStatus {
  status: string;
  bucket: string;
  fileKey: string;
  createdAt: string
  ttl?: number;
};



// WEBPACK FOOTER //
// ./src/models/KansatsuKirokuArchiveStatus.ts